import FaqQuestionsContainer from './FaqQuestionsContainer';
import FaqQuestionsStore from './FaqQuestionsStore';

export default FaqQuestionsStore(FaqQuestionsContainer);